import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useLoader } from "../../contexts/loader";
import { usePermissoesLocalStorage } from "../../utils/usePermissoesLocalStorage";
import { obterStorage } from "../../utils/secureStorage";

export function useAuthRoute(
  WrappedComponent,
  requiredPermission,
  nivelExigido,
  tiposEmpresaPermitidos,
) {
  const { verificarPermissao, verificarNivelNumerico } =
    usePermissoesLocalStorage();

  const { fecharCarregamento, fecharCarregamentoTabela } = useLoader();

  const permissoesRequeridas = Array.isArray(requiredPermission)
    ? requiredPermission
    : requiredPermission
      ? [requiredPermission]
      : [];

  const sessao = obterStorage("sessao") || {};
  const dadosAutenticacao = obterStorage("_da") || {};
  const tipoEmpresa =
    sessao?.empresaDTO?.tipoEmpresa ||
    dadosAutenticacao?.empresaDTO?.tipoEmpresa;
  const rotaRestritaPorTipoEmpresa =
    Array.isArray(tiposEmpresaPermitidos) &&
    tiposEmpresaPermitidos.length > 0;

  let autorizado =
    !rotaRestritaPorTipoEmpresa || tiposEmpresaPermitidos.includes(tipoEmpresa);
  if (permissoesRequeridas.length > 0) {
    const possuiAlgumaPermissao = permissoesRequeridas.some((permission) => {
      const permissao = verificarPermissao(permission);
      return (
        permissao.consultar ||
        permissao.inserir ||
        permissao.alterar ||
        permissao.excluir
      );
    });

    if (!possuiAlgumaPermissao) {
      autorizado = false;
    } else if (nivelExigido) {
      const nivelExigidoNumerico = verificarNivelNumerico(nivelExigido);
      const nivelMaximoUsuario = Math.max(
        ...permissoesRequeridas.map((permission) => {
          const permissao = verificarPermissao(permission);
          return permissao.nivel;
        }),
      );

      if (nivelMaximoUsuario < nivelExigidoNumerico) {
        autorizado = false;
      }
    }
  }

  const navigate = useNavigate();

  useEffect(() => {
    if (!autorizado) {
      toast.error("Você não possui permissão para acessar essa página!");
      fecharCarregamentoTabela();
      fecharCarregamento();
      navigate("/");
    }
  }, [autorizado]);

  if (!autorizado) {
    return null;
  }

  return <WrappedComponent />;
}
